class ShopTheLookList extends HTMLElement {
  constructor () {
    super()

    this.state = {
      variantsToAdd: this.variantIds,
    }

    this.els = {
      addAllToBag: this.querySelector('[data-shop-the-look-list-el="addAllToBag"]'),
    }
  }

  connectedCallback () {
    this.setupEventListeners()
  }

  setupEventListeners () {
    this.querySelectorAll('input[name="id"]').forEach(input => {
      input.addEventListener('change', this.handleVariantChange.bind(this))
    })

    this.els.addAllToBag.addEventListener('click', this.handleAddAllToBag.bind(this))
  }

  handleVariantChange (event) {
    const variants = this.variantIds.map(variant => {
      if (variant.el === event.target) {
        variant.id = event.target.value
      }

      return variant
    })

    this.variantIds = variants
  }

  set variantIds (variantIds) {
    this.state.variantsToAdd = variantIds
  }

  get variantIds () {
    const inputs = this.querySelectorAll('input[name="id"]')
    return Array.from(inputs).map(input => {
      const variantId = input.value

      return {
        id: variantId,
        el: input,
      }
    })
  }

  handleAddAllToBag () {
    const items = this.state.variantsToAdd.map(variant => ({
      id: variant.id,
      quantity: 1,
    }))

    document.body.dispatchEvent(
      new CustomEvent('push-cart:add-items', {
        detail: {
          items,
        },
      }),
    )
  }
}

customElements.define('shop-the-look-list', ShopTheLookList)
